export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q03_b.83d8d8bf.png";